import { ifCanPushDatalayer, pageTypeIncludes } from "./utils/utils.dataLayer.common";
import categorizeMarketoFormSubmission from "./form-categorize-submission.common";

//UCS003
const dataLayerFormFreeTrial = (userStatus, userEmail, marketoIDF) => {
    ifCanPushDatalayer({
        then: () => {
            if (pageTypeIncludes("free-trial")) {
                if (userEmail) {
                    categorizeMarketoFormSubmission({
                        userEmail,
                        userStatus,
                        leadType: "free_trial",
                        marketoIDF
                    });
                }
            }
        },
    });
};

export default dataLayerFormFreeTrial;
